import axios from 'axios'

const request = axios

export default request
